import { Component, Input } from '@angular/core';
import { AbstractComponent } from '../../components/abstract-component/abstract.component';
import { ListLoader } from '../../components/list-loader/list-loader';
import { Router } from '@angular/router';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { ComparatorService } from '../../services/comparator-service';
import { BodenbedeckungVersionDetailEntry } from '../../../core/av-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ViewModelBodenbedeckungEntry } from '../../../core/services/bodenbedeckung-viewmodel.service';
import { ListLoaderWrapperComponent } from '../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../directives/history.directive';
import { KompaktTimepointComponent } from '../../kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DecimalHochkommaPipe } from '../../pipes/simple/decimalHochkomma.pipe';
import BodenbedeckungArtEnum = BodenbedeckungVersionDetailEntry.BodenbedeckungArtEnum;

@Component({
  selector: 'cap-bodenbedeckung-table',
  templateUrl: './bodenbedeckung-table.component.html',
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, HistoryDirective, KompaktTimepointComponent, TranslatePipe, DecimalHochkommaPipe]
})
export class BodenbedeckungTableComponent extends AbstractComponent {
  private _listLoader: ListLoader<ViewModelBodenbedeckungEntry>;

  @Input()
  hasRight = true;

  constructor(
    protected router: Router,
    protected appformatConfigService: FormatConfigService,
    protected comparatorService: ComparatorService
  ) {
    super();
    keysToTranslate<BodenbedeckungArtEnum>([
      'BEFESTIGT_STRASSE_WEG',
      'BEFESTIGT_TROTTOIR',
      'BEFESTIGT_VERKEHRSINSEL',
      'BEFESTIGT_BAHN',
      'BEFESTIGT_FLUGPLATZ',
      'BEFESTIGT_WASSERBECKEN',
      'BEFESTIGT_UEBRIGE_BEFESTIGTE',
      'HUMUSIERT_ACKER_WIESE_WEIDE',
      'HUMUSIERT_INTENSIVKULTUR_REBEN',
      'HUMUSIERT_INTENSIVKULTUR_UEBRIGE_INTENSIVKULTUR',
      'HUMUSIERT_GARTENANLAGE',
      'HUMUSIERT_HOCH_FLACHMOOR',
      'HUMUSIERT_UEBRIGE_HUMUSIERTE',
      'GEWAESSER_STEHENDES',
      'GEWAESSER_FLIESSENDES',
      'GEWAESSER_SCHILFGUERTEL',
      'BESTOCKT_GESCHLOSSENER_WALD',
      'BESTOCKT_WYTWEIDE_WYTWEIDE_DICHT',
      'BESTOCKT_WYTWEIDE_WYTWEIDE_OFFEN',
      'BESTOCKT_UEBRIGE_BESTOCKTE',
      'VEGETATIONSLOS_FELS',
      'VEGETATIONSLOS_GLETSCHER_FIRN',
      'VEGETATIONSLOS_GEROELL_SAND',
      'VEGETATIONSLOS_ABBAU_DEPONIE',
      'VEGETATIONSLOS_UEBRIGE_VEGETATIONSLOSE',
      'GEBAEUDE_HOFRAUM_GARTEN_ANLAGE_BISHER',
      'STRASSE_WEG_TROTTOIR_RAV',
      'BAHNEN_STRASSEN_WEGE_BISHER',
      'ACKER_WIESE_PFLANZLAND_BAUMGARTEN_BISHER',
      'WEIDEN_BISHER',
      'REBEN_BISHER',
      'GEWAESSER_BISHER',
      'WYTWEIDE_UEBRIGE_BESTOCKTE',
      'WALD_BISHER',
      'WEIDWALD_BISHER',
      'UNKULTIVIERTES_GEBIET_BISHER',
      'UNBESTIMMT',
      'RUNDUNGSDIFFERENZ'
    ]);
  }

  @Input()
  set listLoader(listLoader: ListLoader<ViewModelBodenbedeckungEntry>) {
    if (!listLoader) {
      return;
    }
    this._listLoader = listLoader;
  }

  get listLoader(): ListLoader<ViewModelBodenbedeckungEntry> {
    return this._listLoader;
  }

  protected readonly BodenbedeckungArtEnum = BodenbedeckungArtEnum;
}
